import React from "react"
import PropTypes from "prop-types"

import {injectIntl, FormattedMessage} from "@irati/utils/lang"
import {Para} from "@irati/ui/src/Labels"
import getId from "@irati/utils/id"
import {Radio, ToolTipRenderer} from "@irati/ui/src/FormItem"

const StopOptions = ({onChange, formatMessage, selectedStopType, options, ...props}) => {
  const idNamespace = getId("StopOptions", props)
  const radioLabel = formatMessage({id: "insights.homepage.actions.stop.description"})
  return (
    <>
      <Radio
        label={radioLabel}
        rowRenderer={ToolTipRenderer}
        id={idNamespace}
        name="StopOptionsGroup"
        onChange={onChange}
        value={selectedStopType}
        options={options} />
      <Para>
        <FormattedMessage id="insights.homepage.actions.stop.descriptionFooter" />
      </Para>
    </>
  )
}

StopOptions.propTypes = {
  onChange: PropTypes.func.isRequired,
  formatMessage: PropTypes.func.isRequired,
  selectedStopType: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired
}

export default injectIntl(StopOptions)
